var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.488155 0.987311C0.800716 0.67475 1.22464 0.499155 1.66667 0.499155C2.10869 0.499155 2.53262 0.67475 2.84518 0.987311L16.9873 15.1294C17.2999 15.442 17.4755 15.8659 17.4755 16.308C17.4755 16.75 17.2999 17.1739 16.9873 17.4865C16.6747 17.799 16.2508 17.9746 15.8088 17.9746C15.3668 17.9746 14.9428 17.799 14.6303 17.4865L0.488155 3.34433C0.175595 3.03177 -4.21467e-08 2.60785 0 2.16582C4.2147e-08 1.72379 0.175594 1.29987 0.488155 0.987311Z",
    fill: "#004E72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.845178 16.9873C0.532617 16.6747 0.357023 16.2508 0.357023 15.8088C0.357023 15.3668 0.532617 14.9428 0.845178 14.6303L14.9873 0.488156C15.2999 0.175595 15.7238 -4.21468e-08 16.1658 0C16.6079 4.21468e-08 17.0318 0.175595 17.3443 0.488155C17.6569 0.800716 17.8325 1.22464 17.8325 1.66667C17.8325 2.10869 17.6569 2.53262 17.3443 2.84518L3.2022 16.9873C2.88964 17.2999 2.46572 17.4755 2.02369 17.4755C1.58166 17.4755 1.15774 17.2999 0.845178 16.9873Z",
    fill: "#004E72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.6e0e17d720530f83e86130b1e3d6db20.svg";
export { ForwardRef as ReactComponent };